import { render, staticRenderFns } from "./SafetyInspectionTable.vue?vue&type=template&id=28ea2485"
import script from "./SafetyInspectionTable.vue?vue&type=script&lang=js"
export * from "./SafetyInspectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports